
function popupShow(id){
    document.querySelector("#" + id).classList.add('show');
    document.querySelector('body').classList.add('no-overflow');
    document.querySelector('body').classList.add('overlay');
}

function popupHide(id){
    document.querySelector('#' + id).classList.remove('show');
    document.querySelector('body').classList.remove('no-overflow');
    document.querySelector('body').classList.remove('overlay');
}

function init(){
    let popupToggleButtons = document.querySelectorAll('[data-popup-toggle]'),
        popupCloseButtons = document.querySelectorAll('[data-popup-close]'),
        popupID = '';


    popupToggleButtons.forEach((button) => {

        button.addEventListener('click', () => {
            popupID = button.getAttribute('data-popup-toggle');
            popupShow(popupID);

        });
    });

    popupCloseButtons.forEach((button) => {

        button.addEventListener('click', () => {

            popupHide(popupID);

        });
    });
}

export default {init, popupHide};
